export class UserChatDetail {
    id: number;
    userName: string;
    userExternalId: string;
    uuid: string;
    chatName: string;
    createdDateTime: Date | null;
    updatedDateTime: Date | null;
    isActive:boolean;
    date_group:string;

    constructor() {
        this.id = 0;
        this.userName = "";
        this.userExternalId = "";
        this.uuid = "";
        this.chatName = "";
        this.createdDateTime = null;
        this.updatedDateTime = null;
        this.isActive = false;
        this.date_group = "";
    }
}

export class ChatHistoryDetail {
    id: number;
    userExternalId: string;
    uuid: string;
    chatHistory: string;
    attachment: string;
    createdDateTime: Date | null;
    updatedDateTime: Date | null;

    constructor() {
        this.id = 0;
        this.chatHistory = "";
        this.userExternalId = "";
        this.uuid = "";
        this.attachment = "";
        this.createdDateTime = null;
        this.updatedDateTime = null;
    }
}
export class AttachmentDetails{
    id:number;
    azureFileName:string;
    displayName:string;
    fileType:string;
    azureContainerName:string;
    externalUrl:string;
    mD5:string;
    globalAccess:boolean;
    updatesID:number;
    metadata:string;
    constructor(){
        this.id = 0;
        this.azureContainerName = "";
        this.azureFileName = "";
        this.displayName = "";
        this.fileType = "";
        this.externalUrl = "";
        this.mD5 = "";
        this.globalAccess = false;
        this.updatesID = 0;
        this.metadata = "";
    }
}


export class UpdateExtractedRigFile{
    uuid:string;
    attachmentDetails:Array<AttachmentDetails>;
    changeViewerId: number;
    constructor(){
        this.uuid = "";
        this.attachmentDetails = [];
        this.changeViewerId = 0;
    }
}

export class MonthChat{
    month:string;
    chats:UserChatDetail;
    isActive:boolean;

    constructor(){
        this.month = "";
        this.chats = new UserChatDetail;
        this.isActive = false;
    }
}

export class OtherMonthChat{
    month:string;
    chats:Array<UserChatDetail>;

    constructor(){
        this.month = "";
        this.chats = [];
    }
}

// export class Metadata{
//     format:string = "";
//     title:string = "";
//     author:string = "";
//     subject:string = "";
//     keywords:string = "";
//     creator:string = "";
//     producer:string = "";
//     creationDate:string = "";
//     modDate:string = "";
//     trapped:string = "";
//     encryption:string = "";
//     suggestedName:string = "";
// }

